import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import QuickSaleForm from '../components/QuickSaleForm';
import DetailedSaleForm from '../components/DetailedSaleForm';
import '../styles/Sales.css';

const Sales = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [saleType, setSaleType] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  
  // Verificar si la venta detallada está deshabilitada (para suscripciones tipo 'personal')
  const disableDetailedSale = location.state?.disableDetailedSale || false;

  const handleSaleTypeSelection = (type) => {
    setSaleType(type);
  };

  const handleSaleAdded = () => {
    // Mostrar mensaje de éxito
    setSuccessMessage('Venta registrada exitosamente');
    
    // Limpiar el mensaje después de 3 segundos
    setTimeout(() => {
      setSuccessMessage('');
      // Volver al tipo de selección
      setSaleType(null);
    }, 3000);
  };

  const handleCancel = () => {
    // Volver a la selección de tipo de venta
    setSaleType(null);
  };

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="sales-container">
      <header className="sales-header">
        <h1>Registro de Ventas</h1>
        <button onClick={handleBackToDashboard} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      {!saleType ? (
        <div className="sale-type-selection">
          <h2>Seleccione el tipo de venta</h2>
          <div className="sale-type-buttons">
            <button 
              className="sale-type-btn quick-sale-btn"
              onClick={() => handleSaleTypeSelection('quick')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              <span>Venta Rápida</span>
              <p>Registre una venta con información mínima</p>
            </button>
            <button 
              className={`sale-type-btn detailed-sale-btn ${disableDetailedSale ? 'disabled' : ''}`}
              onClick={() => handleSaleTypeSelection('detailed')}
              disabled={disableDetailedSale}
              title={disableDetailedSale ? 'No disponible en suscripción personal' : 'Registre una venta con todos los detalles'}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
              <span>Venta Detallada</span>
              <p>Registre una venta con todos los detalles</p>
            </button>
          </div>
        </div>
      ) : saleType === 'quick' ? (
        <QuickSaleForm 
          onSaleAdded={handleSaleAdded}
          onCancel={handleCancel}
        />
      ) : (
        <DetailedSaleForm 
          onSaleAdded={handleSaleAdded}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default Sales;
